<script setup lang="ts">
import VersionChecker from "@/components/shared/VersionChecker.vue";
import NavBarPublic from "../components/shared/navbar/NavBar.public.vue";
</script>

<template>
  <v-layout>
    <nav-bar-public />
    <v-main>
      <v-container class="tw:!max-w-[1366px] tw:!h-full tw:!pb-16 tw:!px-4 tw:md:!px-6">
        <VersionChecker />
        <router-view />
      </v-container>
    </v-main>
  </v-layout>
</template>
